// @ts-nocheck
import { Navigate } from 'react-router-dom';
import useAuth from '../hooks/useAuth';

// Campaigns is restricted to builders / office-admins whose builder context is
// on the backend allow-list (CAMPAIGN_ENABLED_BUILDER_IDS, surfaced as
// user.campaignsEnabled on /v1/auth/me). Bounce anyone else who reaches a
// /dashboard/campaigns URL directly — the API would 403 them anyway.
export default function CampaignsGuard({ children }) {
  const { user } = useAuth();
  const allowedRole = user?.role === 'builder' || user?.role === 'officeadmin';

  if (!allowedRole || !user?.campaignsEnabled) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
